import { Component, Input } from '@angular/core';
import { I18nService } from '@localize/services';

@Component({
	selector: 'app-display-table',
	templateUrl: './display-table.component.html',
	styleUrls: ['./display-table.component.scss']
})
export class DisplayTableComponent {
	@Input() data = []; // List to render
	@Input() dataAttr: string; // Depending data[] structure define attr to display
	@Input() title: string; // Table title
	@Input() loading = false; // To trigger loader if needed

	public i18nCopyToClipboardMsg = this.i18nService.get('Copied to clipboard', 'app.action.copied-to-clipboard');

	constructor(private i18nService: I18nService) {}
}
